/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2026 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import { PlaylistClip } from "types/Clip";
import { BlockTypes } from "constants/BlockTypes";
import { AudioEffect } from "types/AudioEffect";
import { createLogger, EnhancedLogger } from "utilities/Logger";

export class BackgroundEffect extends AudioEffect {
  static canBuildFor(clip: PlaylistClip): boolean {
    return clip.type === BlockTypes.WAVEFORM && clip.isBackground;
  }

  private readonly gainNode: GainNode;

  constructor(
    audioContext: AudioContext,
    clip: PlaylistClip,
    playlistTime: number,
    logger?: EnhancedLogger
  ) {
    super(audioContext, clip, playlistTime, logger);
    this.gainNode = this.audioContext.createGain();
    this.gainNode.gain.value = 0.1;
  }

  hotswap(newClip: PlaylistClip): void {}

  get inputNode(): AudioNode {
    return this.gainNode;
  }

  get outputNode(): AudioNode {
    return this.gainNode;
  }

  disconnect(): void {
    this.gainNode.disconnect();
  }
}
